import pullover from '../Images/Pullover.jpg'
import cargo from '../Images/Cargo.jpg'
import tshirt from '../Images/tshirt.jpg'
import tshirt2 from '../Images/tshirt2.jpg'
import sneaker from '../Images/sneaker.jpg'
import pants from '../Images/pants.jpg'
import pants2 from '../Images/pants2.jpg'
import bag from '../Images/bag.jpg'
import shorts from '../Images/shorts.jpg'
import shoes from '../Images/shoes.jpg'
import crop from '../Images/crop.jpg'
import tgirl from '../Images/tgirl.jpg'
import mock from '../Images/mockneck.jpg'
import pantsg from '../Images/pantsg.jpg'
import bodydress from '../Images/bodydress.jpg'
import skirt from '../Images/skirt.jpg'
import skirt2 from '../Images/skirt2.jpg'
import frock from '../Images/frock.jpg'
import starspant from '../Images/starspant.jpg'
import gothtop from '../Images/gothtop.jpg'
import minidress from '../Images/minidress.jpg'
import heaven from '../Images/heaven.jpg'
import hoodie from '../Images/hoodie.jpg'
import whoodie from '../Images/whoodie.jpg'
import nezuko from '../Images/nezuko.jpg'
import toji from '../Images/toji.jpg'
import street from '../Images/street.jpg'
import paused from '../Images/paused.jpg'
import shinobu from '../Images/shinobu.jpg'
import cute from '../Images/cute.jpg'
import akat from '../Images/akat.jpg'
import naruto from '../Images/naruto.jpg'
import gothf from '../Images/gothf.jpg'
import gothT from '../Images/gothT.jpg'
import gothf2 from '../Images/gothf2.jpg'
import skull from '../Images/skull.jpg'
import skull2 from '../Images/skull2.jpg'
import gothicWT from '../Images/gothicWT.jpg'
import punk from '../Images/punk.jpg'
import spider from '../Images/spider.jpg'
import chain from '../Images/chain.jpg'
import keychain from '../Images/keychain.jpg'
import starchain from '../Images/starchain.jpg'
import skeleton from '../Images/skeleton.jpg'
import gchain from '../Images/gchain.jpg'
import heartchain from '../Images/heartchain.jpg'
import heartbrace from '../Images/heartbrace.jpg'
import erings from '../Images/erings.jpg'
import erings2 from '../Images/erings2.jpg'
import eringsg from '../Images/eringsg.jpg'
import bear from '../Images/bear.jpg'
import bear2 from '../Images/bear2.jpg'
import starhoodie from '../Images/starhoodie.jpg'
import bracelet from '../Images/bracelet.jpg'
import bracelet2 from '../Images/bracelet2.jpg'

export const men = [
    {
        name: 'Pullover Hoodie Men Patchwork Hoodies',
        alt: 'Hoodie',
        picture: pullover,
        link: `https://amzn.to/3OXoSI2`,
    },
    {
        name: "Hello MrLin Men's Jogger Pants Techwear",
        alt: 'Cargo Pants',
        picture: cargo,
        link: 'https://amzn.to/49vM8VL',
    },
    {
        name: 'Men’s Techwear Streetwear Short Sleeve T-Shirts',
        alt: 'Hip Hop Tshirt',
        picture: tshirt,
        link: 'https://amzn.to/3wFWLqn',
    },
    {
        name: "Gothic Casual Pants Men'sTrousers Casual Pants",
        alt: '',
        picture: 'https://m.media-amazon.com/images/I/61P-Xxi8UKL._AC_SX679_.jpg',
        link: 'https://amzn.to/48YfcV1',
    },
    {
        name: "Men's Tactical Cargo Techwear Pants for Men",
        alt: '',
        picture: 'https://m.media-amazon.com/images/I/61kY9OawfEL._AC_SX679_.jpg',
        link: 'https://amzn.to/4chx3Je',
    },
    {
        name: "Womens Canvas Sneakers Casual Shoes",
        alt: '',
        picture: 'https://m.media-amazon.com/images/I/71ReJmzvX+L._AC_SY695_.jpg',
        link: 'https://amzn.to/3Vfv424',
    },
    {
        name: "Converse Unisex-Adult All Star Canvas Sneaker",
        alt: '',
        picture: 'https://m.media-amazon.com/images/I/71L+xY5BPHL._AC_SX695_.jpg',
        link: 'https://amzn.to/3vcX7V9',
    },
    {
        name: "Mask Adjustable Cosplay Costume Movie Shooting",
        alt: '',
        picture: 'https://m.media-amazon.com/images/I/71gote4uFBL._AC_SX679_.jpg',
        link: 'https://amzn.to/3TCdqnN',
    },
    {
        name: "RICK AND MORTY Mens Sweatpants Classic Sweatpants",
        alt: '',
        picture: 'https://m.media-amazon.com/images/I/71d26oxRZ2L._AC_SX679_.jpg',
        link: 'https://amzn.to/49U9xAn',
    },
    {
        name: "Men’s Hooded Windbreaker Jacket Hoodie",
        alt: '',
        picture: 'https://m.media-amazon.com/images/I/61qi0fcNlEL._AC_SX679_.jpg',
        link: 'https://amzn.to/3ICqy6j',
    },
    {
        name: "Unisex Canvas Shoes for Men Women Sneakers",
        alt: '',
        picture: 'https://m.media-amazon.com/images/I/51PwMrqTNHL._AC_SY695_.jpg',
        link: 'https://amzn.to/491oyiy',
    },
    {
        name: "Streetwear Cyberpunk Elbow Sleeve Graphic Tees Men",
        alt: '',
        picture: 'https://m.media-amazon.com/images/I/61d1XWzgGaL._AC_SX679_.jpg',
        link: 'https://amzn.to/3IFYA9S',
    },
    {
        name: "Men's Running Shoes Blade Type Sneakers",
        alt: 'Sneakers',
        picture: sneaker,
        link: 'https://amzn.to/3USzBas',
    },
    {
        name: "Streetwear Men's Techwear Pants with Straps",
        alt: 'Cargo pants',
        picture: pants,
        link: 'https://amzn.to/48By9fM',
    },
    {
        name: "Men's Graphic Tees Vintage T-Shirts Streetwear",
        alt: 'Printed tshirt',
        picture: heaven,
        link: 'https://amzn.to/3V0dMpI',
    },
    {
        name: "Men's Flap Pocket Techwear Cargo Pants",
        alt: 'Pants',
        picture: pants2,
        link: 'https://amzn.to/3wzedNu',
    },
    {
        name: "Men's Techwear Backpack Japanese Bag",
        alt: 'Backpack',
        picture: bag,
        link: 'https://amzn.to/3UQomzm',
    },
    {
        name: "Casual Short-Sleeved T-Shirt for Men",
        alt: 'Hip Hop Tshirt',
        picture: tshirt2,
        link: 'https://amzn.to/49uGgvV',
    },
    {
        name: "Fashion Mens Women Sneakers Shoe for Men",
        alt: 'Shoes',
        picture: shoes,
        link: 'https://amzn.to/3IhgX4E',
    },
    {
        name: 'Techwear Shorts Mens Cargo Pants',
        alt: 'Shorts',
        picture: shorts,
        link: 'https://amzn.to/4bMw6bP',
    },
    {
        name: 'Men’s T-Shirts Techwear Streetwear for Men',
        alt: 'techware baggy oversized',
        picture: 'https://m.media-amazon.com/images/I/51-7ZI2pDiL._AC_SX679_.jpg',
        link: 'https://amzn.to/3V1phgg',
    },
    {
        name: 'Mens Joggers Pants Casual Pant',
        alt: 'cargo techwear',
        picture: 'https://m.media-amazon.com/images/I/51WDSV88kPL._AC_SX679_.jpg',
        link: 'https://amzn.to/431nWbk',
    },
    {
        name: 'Japanese Streetwear Jackets for Men',
        alt: 'hoodie techwear',
        picture: 'https://m.media-amazon.com/images/I/61bayuWMebL._AC_SX679_.jpg',
        link: 'https://amzn.to/3V2QNds',
    },
    {
        name: 'Hoodies for Men Pullover Sweatshirt',
        alt: 'hoodie',
        picture: 'https://m.media-amazon.com/images/I/71x+WUT1EOL._AC_SX679_.jpg',
        link: 'https://amzn.to/3T4jaVY',
    },
    {
        name: 'Mens Cargo Pants Techwear Sweatpants',
        alt: 'cargo techware',
        picture: 'https://m.media-amazon.com/images/I/51fHZTBkdOL._AC_SX679_.jpg',
        link: 'https://amzn.to/48GUbxE',
    },
    {
        name: "Men's Punk Rock Street Pants",
        alt: 'cargo techwear',
        picture: 'https://m.media-amazon.com/images/I/51XgQ1PAETS._AC_SX569_.jpg',
        link: 'https://amzn.to/48DTYLJ',
    },
    {
        name: 'Mens Sneakers High Top Shoes Shoe Men',
        alt: 'shoes techwear',
        picture: 'https://m.media-amazon.com/images/I/41HUm2YO-yL._AC_.jpg',
        link: 'https://amzn.to/49yHS83',
    },
    {
        name: "Men's Streetwear Novelty Cargo Ankle Pants",
        alt: 'techwear cargo',
        picture: 'https://m.media-amazon.com/images/I/71I3b3g1iaL._AC_SY879_.jpg',
        link: 'https://amzn.to/3T3emA3',
    },
    {
        name: "Men's Joggers Punk Cargo Baggy Techwear Pants",
        alt: 'techwear cargo pants',
        picture: 'https://m.media-amazon.com/images/I/61vnILvWNoL._AC_SY879_.jpg',
        link: 'https://amzn.to/3P4tLz6',
    },
    {
        name: "Men's White Pants Techwear Cargo for Men",
        alt: 'techwear cargo',
        picture: 'https://m.media-amazon.com/images/I/61Y0YveGksL._AC_SX679_.jpg',
        link: 'https://amzn.to/3uYk1Q7',
    },
    {
        name: 'Adult Ultra Cotton Long Sleeve T-Shirt',
        alt: 'long sleeve tshirt',
        picture: 'https://m.media-amazon.com/images/I/715bY3uEYgL._AC_SX679_.jpg',
        link: 'https://amzn.to/3uUENQB',
    },
    {
        name: "Athletic Men's Cotton Sleeveless T-shirt",
        alt: 'sleeveless tshirt',
        picture: 'https://m.media-amazon.com/images/I/71riW1CVmzL._AC_SX679_.jpg',
        link: 'https://amzn.to/3P5xDQn',
    },
    {
        name: "Men's Sweatshirts Casual Pullover Shirt",
        alt: 'long sleeve tshirt',
        picture: 'https://m.media-amazon.com/images/I/71DRFI1qYFL._AC_SY879_.jpg',
        link: 'https://amzn.to/3TjOdhN',
    },
    {
        name: 'Mens Casual Long Sleeve Business Dress Shirts',
        alt: 'business dress formal',
        picture: 'https://m.media-amazon.com/images/I/613XL7f-hGL._AC_SY879_.jpg',
        link: 'https://amzn.to/3UXUTDL',
    },
    {
        name: "Men's Techwear Waterproof Windbreaker Hoodie",
        alt: 'hoodie',
        picture: 'https://m.media-amazon.com/images/I/71gA4nBlKTL._AC_SX679_.jpg',
        link: 'https://amzn.to/4a0vZrn',
    },
    {
        name: 'Sling Bag Crossbody Bags for Men Women',
        alt: 'backpack',
        picture: 'https://m.media-amazon.com/images/I/91AthIG5XDL._AC_SX679_.jpg',
        link: 'https://amzn.to/3wvwmvp',
    },
    {
        name: "Men's Letter Graphic Print T Shirts",
        alt: 'tshirt oversized',
        picture: 'https://m.media-amazon.com/images/I/71XihYZ4mqL._AC_SY741_.jpg',
        link: 'https://amzn.to/3P74sfQ',
    },
    {
        name: 'Mens Short Sleeve Tshirts Oversize Tees',
        alt: 'oversized tshirt',
        picture: 'https://m.media-amazon.com/images/I/61RSgnwX30L._AC_SX679_.jpg',
        link: 'https://amzn.to/3P6OYZ4',
    },
    {
        name: "Men's Print Short Sleeve T Shirt Casual",
        alt: 'oversized tshirt',
        picture: 'https://m.media-amazon.com/images/I/61HMraWUz-L._AC_SY879_.jpg',
        link: 'https://amzn.to/4c2jDRs',
    },
]

export const women = [
    {
        name: 'Crop Top Techwear Shirt Outfits For Women',
        alt: 'crop top',
        picture: crop,
        link: 'https://amzn.to/3uRzz89',
    },
    {
        name: 'Hello Kitty And Friends Short Sleeve T-Shirt',
        alt: 'woman tshirt',
        picture: tgirl,
        link: 'https://amzn.to/49RP2no',
    },
    {
        name: "Women's 2 Piece Dresses Sexy Tops Mini Dress",
        alt: 'mini dress',
        picture: minidress,
        link: 'https://amzn.to/49CdYjq',
    },
    {
        name: "Sexy Women Bodysuit Summer Streetwear Outfit",
        alt: '',
        picture: 'https://m.media-amazon.com/images/I/51qcAXWZELL._AC_SX679_.jpg',
        link: 'https://amzn.to/43rorvK',
    },
    {
        name: "Women Grunge Crop Tops Baggy Streetwear",
        alt: '',
        picture: 'https://m.media-amazon.com/images/I/71A1Wrx+14L._AC_SX679_.jpg',
        link: 'https://amzn.to/4ca1G3c',
    },
    {
        name: "Sexy Lace Mini Skirts for Women Fashion Skirt",
        alt: '',
        picture: 'https://m.media-amazon.com/images/I/619KYX2mDdL._AC_SY741_.jpg',
        link: 'https://amzn.to/48YVx7l',
    },
    {
        name: "Women's Booty Shorts High Waisted Gym Shorts",
        alt: '',
        picture: 'https://m.media-amazon.com/images/I/61dz6xwR0wL._AC_SX679_.jpg',
        link: 'https://amzn.to/3PmMGoW',
    },
    {
        name: "Backpack for Girls Kids Schoolbag Women",
        alt: '',
        picture: 'https://m.media-amazon.com/images/I/71i+scVCuIL._AC_SY300_SX300_.jpg',
        link: 'https://amzn.to/43rvqoj',
    },
    {
        name: "Sports Bra for Women Sexy Crop Tops",
        alt: '',
        picture: 'https://m.media-amazon.com/images/I/81n+iHvWALL._AC_SX679_.jpg',
        link: 'https://amzn.to/49SwDaN',
    },
    {
        name: "Heart Leather Necklace for Women Girls",
        alt: '',
        picture: 'https://m.media-amazon.com/images/I/518pxZdhALL._AC_SY675_.jpg',
        link: 'https://amzn.to/3TmqE72',
    },
    {
        name: "Extra Long High Thigh Socks Thin Stocking",
        alt: '',
        picture: 'https://m.media-amazon.com/images/I/61HcdCxInpL._AC_SX679_.jpg',
        link: 'https://amzn.to/3TmYicP',
    },
    {
        name: "Women Gothic Punk Mini Dress Grunge Aesthetic",
        alt: '',
        picture: 'https://m.media-amazon.com/images/I/51nOd3zt5eL._AC_SX679_.jpg',
        link: 'https://amzn.to/3PnHFg2',
    },
    {
        name: "Women's Gothic Black Dress Off-Shoulder Dress",
        alt: '',
        picture: 'https://m.media-amazon.com/images/I/61OQX+xq2IL._AC_SX679_.jpg',
        link: 'https://amzn.to/43k2BKm',
    },
    {
        name: "Pants for Women Baggy Cargo Pants Trousers",
        alt: '',
        picture: 'https://m.media-amazon.com/images/I/513PGub73BL._AC_SY879_.jpg',
        link: 'https://amzn.to/4cjZQN8',
    },
    {
        name: "Unisex Hoodie Streetwear Sweatshirt",
        alt: '',
        picture: 'https://m.media-amazon.com/images/I/71ATiRl8u+L._AC_SX679_.jpg',
        link: 'https://amzn.to/3wPvh1G',
    },
    {
        name: 'MANGOPOP Mock Neck Cutout Bodysuit Sleeveless for Women Tops',
        alt: 'womans tops',
        picture: mock,
        link: 'https://amzn.to/49OiQBB',
    },
    {
        name: 'AULKEEP for Women Goth High Waist Trousers Sexy Hollow Black Pants',
        alt: 'Pants',
        picture: pantsg,
        link: 'https://amzn.to/3uFEtFr',
    },
    {
        name: 'OQQ Women 2 Piece Skirts 2 in 1 Versatile Stretchy Casual Mini Skirts',
        alt: 'Skirts woman',
        picture: skirt2,
        link: 'https://amzn.to/3SYuF14',
    },
    {
        name: "Verdusa Women's Crisscross High Split Mock Neck Sleeveless Dress",
        alt: 'body dress',
        picture: bodydress,
        link: 'https://amzn.to/3SX7KTP',
    },
    {
        name: "WDIRARA Women's High Waist Pleated Button Skirt Shorts",
        alt: 'skirt',
        picture: skirt,
        link: 'https://amzn.to/42XOL0a',
    },
    {
        name: "KUTUMAI Women's Summer Sleeveless Long Dress",
        alt: 'frock',
        picture: frock,
        link: 'https://amzn.to/42YFc0M',
    },
    {
        name: "Women's Black and White Cargo Pants Trousers Halloween",
        alt: 'pants',
        picture: starspant,
        link: 'https://amzn.to/3wvaDUC',
    },
    {
        name: "Women's Y2K Gothic Crop Tops Graphic Skull Print T Shirts",
        alt: 'gothic crop top',
        picture: gothtop,
        link: 'https://amzn.to/42Xgzll',
    },
    {
        name: "Black Cargo Pants for Women Techwear Casual Black Pants",
        alt: "goth women cargo techwear",
        picture: 'https://m.media-amazon.com/images/I/61Nb0ktmEzL._AC_SX679_.jpg',
        link: 'https://amzn.to/3wKJhtu',
    },
    {
        name: "Goth Black Mini Skirt with Chain High Waisted Tennis Skirt",
        alt: "skirt techwear",
        picture: 'https://m.media-amazon.com/images/I/51Q6-uNd2JL._AC_SX679_.jpg',
        link: 'https://amzn.to/48D6tHx',
    },
    {
        name: "Women Wide Sleeve Casual Pullover Crop Top",
        alt: "long sleeve crop top",
        picture: 'https://m.media-amazon.com/images/I/613UYzKsapL._AC_SX679_.jpg',
        link: 'https://amzn.to/3v1zzT2',
    },
    {
        name: "Womens Cat Ear Hoodie Sweatshirt Crop Top Hoodies",
        alt: "women hoodie",
        picture: 'https://m.media-amazon.com/images/I/51WDuEVVb-L._AC_SX679_.jpg',
        link: 'https://amzn.to/4bYQczu',
    },
    {
        name: "Women's Gothic Print Long Sleeve Iron Chain Hoodie Sweater ",
        alt: "long sleeve crop top",
        picture: 'https://m.media-amazon.com/images/I/71TCJc7qzUL._AC_SY741_.jpg',
        link: 'https://amzn.to/3P5Wjbg',
    },
    {
        name: "Harajuku Pants Women Fashion High Pants",
        alt: "cargo women techwear pants",
        picture: 'https://m.media-amazon.com/images/I/51CYeLTaBfL._AC_SX679_.jpg',
        link: 'https://amzn.to/3T3DHtK',
    },
    {
        name: "Goth Shirt Gothic Shirt Alternative Clothing Goth Long Sleeve Grunge",
        alt: "long sleeve tshirt girl",
        picture: 'https://m.media-amazon.com/images/I/51q8KXHYtdL._AC_SX679_.jpg',
        link: 'https://amzn.to/3Ilbb1P',
    },
    {
        name: "Gothic T Shirt Women Butterfly Print Short Sleeve T Shirt Women",
        alt: "oversizd tshirt women",
        picture: 'https://m.media-amazon.com/images/I/61oGZLak0BL._AC_SX679_.jpg',
        link: 'https://amzn.to/3wFCJwr',
    },
    {
        name: "Pants for Women Goth Pants Baggy Pants for Women Alt Clothing",
        alt: "pants women",
        picture: 'https://m.media-amazon.com/images/I/51OFh1m3NyL._AC_SX679_.jpg',
        link: 'https://amzn.to/3uRL53x',
    },
    {
        name: "Women's Alt Button Down Shirt Gothic Techwear Aesthetic",
        alt: "women techwear",
        picture: 'https://m.media-amazon.com/images/I/51AO3rgrc+L._AC_SX679_.jpg',
        link: 'https://amzn.to/3Tllk56',
    },
    {
        name: "STAR Goth Crop Top Gothic Y2k Camisole Tops for Women",
        alt: "sleeveless tshirt women",
        picture: 'https://m.media-amazon.com/images/I/71+Y+BLkC-L._AC_SX679_.jpg',
        link: 'https://amzn.to/3wO7jDS',
    },
    {
        name: "Women's Long Sleeve Casual Crewneck Dress",
        alt: "office dress women",
        picture: 'https://m.media-amazon.com/images/I/51LHAbhKwTL._AC_SY879_.jpg',
        link: 'https://amzn.to/49CMppX',
    },
    {
        name: "Workwear Jumpsuit Summer Black Short Sleeve Gothic Women's Clothes",
        alt: "women workwear jumpsuit",
        picture: 'https://m.media-amazon.com/images/I/51Y3bxvG5PL._AC_SX679_.jpg',
        link: 'https://amzn.to/3wC5kCT',
    },
    {
        name: "Fabric of the Universe Techwear Fashion Women's Crop Hoodie",
        alt: "women crop hoodie",
        picture: 'https://m.media-amazon.com/images/I/61oRx-xZYcL._AC_SX679_.jpg',
        link: 'https://amzn.to/3TkvPWh',
    },
    {
        name: "Baggy Parachute Pants for Women Girls Cargo Pants",
        alt: "white cargo pants",
        picture: 'https://m.media-amazon.com/images/I/719-shRx6uL._AC_SY741_.jpg',
        link: 'https://amzn.to/48y5k3W',
    },
    {
        name: "Women's Satin Pants Dress Casual Pants with Pockets",
        alt: "woman pants",
        picture: 'https://m.media-amazon.com/images/I/711e5YZ7TqL._AC_SY741_.jpg',
        link: 'https://amzn.to/3uWNRV8',
    },
    {
        name: "Cargo Pants Women High Waist Baggy Techwear",
        alt: "casual woman pants",
        picture: 'https://m.media-amazon.com/images/I/51qDwS5cNBL._AC_SY879_.jpg',
        link: 'https://amzn.to/3P6skA3',
    },
]

export const anime = [
    {
        name: 'Anime Jujutsu Hoodie JJK Cosplay Costume',
        alt: 'Hoodies',
        picture: hoodie,
        link: 'https://amzn.to/3OZ2cr1',
    },
    {
        name: 'Anime Girl Figure Sweater Oversize Sweatshirt Unisex',
        alt: 'woman anime hoodie',
        picture: whoodie,
        link: 'https://amzn.to/49mFpxn',
    },
    {
        name: 'Anime Hoodies Tracksuits Gifts For Youth Adults',
        alt: 'Nezuko hoodie pants woman',
        picture: nezuko,
        link: 'https://amzn.to/4bUJcnd',
    },
    {
        name: "Men's Loose Stretchy Waist Casual Ankle Length Pants",
        alt: 'pants',
        picture: toji,
        link: 'https://amzn.to/3SYup2k',
    },
    {
        name: 'Gothic Streetwear Men Devil Horn Zip Up Hoodies',
        alt: 'Streetware',
        picture: street,
        link: 'https://amzn.to/3TfU7AL',
    },
    {
        name: 'Manga Otaku Anime T Shirt',
        alt: 'anime tshirt',
        picture: paused,
        link: 'https://amzn.to/3UXjAQx',
    },
    {
        name: 'Womens Bikini Set Swimsuit Anime Style Bathing Suit',
        alt: 'shinobu anime ',
        picture: shinobu,
        link: 'https://amzn.to/3TfzCUD',
    },
    {
        name: 'Cute Dress For Girl Two Piece Set Bunny Prints Dresses',
        alt: 'anime cute goth',
        picture: cute,
        link: 'https://amzn.to/49vQtZ8',
    },
    {
        name: 'Unisex Hoodie Print Sweatshirt for Men and Women',
        alt: 'akatsuki hoodie',
        picture: akat,
        link: 'https://amzn.to/3uFMMRD',
    },
    {
        name: 'Anime Hoodie for Men, Anime Pullover Sweater Gifts',
        alt: 'naruto hoodie',
        picture: naruto,
        link: 'https://amzn.to/3SNJFPe',
    }
]

export const gothic = [
    {
        name: "Women's Halloween Dress Black Gothic Dress Cosplay Costume",
        alt: 'gothic frock',
        picture: gothf,
        link: 'https://amzn.to/3IcBfwa',
    },
    {
        name: 'Womens Plus Size Dresses Gothic Party Maxi Dress',
        alt: 'Gothic frock girls',
        picture: gothf2,
        link: 'https://amzn.to/4bWz3Gw',
    },
    {
        name: "Men's Skull/Cobra Print Denim Jean Jacket",
        alt: 'Skull gothic jacket',
        picture: skull,
        link: 'https://amzn.to/3wsw9sS',
    },
    {
        name: "Gothic Women t-Shirt Women's Clothes Street T-Shirt",
        alt: 'Gothic women tshirt',
        picture: gothicWT,
        link: 'https://amzn.to/3V2OK9s',
    },
    {
        name: "Men's Punk Denim Vest Sleeveless Jean Jackets",
        alt: 'punk gothic jacket',
        picture: punk,
        link: 'https://amzn.to/43fkZUZ',
    },
    {
        name: "Goth Shirt Gothic Clothing Goth Top Grunge Clothes",
        alt: 'gothic long sleeve tshirt',
        picture: gothT,
        link: 'https://amzn.to/42X951w',
    },
    {
        name: "Gothic Knitted Sweater Men and Women Fashion",
        alt: 'Skull gothic tshirt',
        picture: skull2,
        link: 'https://amzn.to/3uRMeIe',
    },
    {
        name: "Women Hoodie Fairy Grunge Aesthetic Jacket Gothic",
        alt: 'Red Spider Hoodie',
        picture: spider,
        link: 'https://amzn.to/49OYl7I',
    },
    {
        name: "Star Hoodie Men Grunge Jacket Oversized Streetwear",
        alt: 'grunge gothic star hoodie',
        picture: starhoodie,
        link: 'https://amzn.to/42Ypnat',
    }
]

export const accessories = [
    {
        name: 'Cross Necklace for Men, Stainless Steel Pendant',
        alt: 'silver chain',
        picture: chain,
        link: 'https://amzn.to/3wyWMwq',
    },
    {
        name: 'Beaded Cross Bracelets for Men Women Bracelets',
        alt: 'Bracelets',
        picture: bracelet,
        link: 'https://amzn.to/48D724f',
    },
    {
        name: 'Cross Necklace for Men, Silver Gold Stainless Steel Pendant',
        alt: 'gold chain',
        picture: gchain,
        link: 'https://amzn.to/3P1t2yy',
    },
    {
        name: 'Heart Necklace, Cute Love Pendant Necklaces for Women',
        alt: 'heart pendant chain',
        picture: heartchain,
        link: 'https://amzn.to/3T20uWK',
    },
    {
        name: '12Pcs 8mm Gemstones Stretch Bracelet for Women Bracelets',
        alt: 'bracelets',
        picture: bracelet2,
        link: 'https://amzn.to/3Thd1XL',
    },
    {
        name: 'Silver Star Earrings or Pendant Necklace',
        alt: 'star pendant chain',
        picture: starchain,
        link: 'https://amzn.to/4bZC7Sg',
    },
    {
        name: 'Initial Charm Bracelets for Girls Letters Heart Bracelet',
        alt: 'heart bracelet',
        picture: heartbrace,
        link: 'https://amzn.to/433k5KT',
    },
    {
        name: 'Yellow Gold or Rose Gold Silver Bar Drop Earrings',
        alt: 'earings',
        picture: erings,
        link: 'https://amzn.to/4bYOm1o',
    },
    {
        name: '15 Pairs Earrings, Stainless Steel Earrings for Men Women',
        alt: 'men earings',
        picture: erings2,
        link: 'https://amzn.to/3P2Foqq',
    },
    {
        name: 'Men Women Bear Keychain Pendant Metal Key Ring',
        alt: 'bear keychain',
        picture: bear,
        link: 'https://amzn.to/3V39KN5',
    },
    {
        name: 'Men Women Bear Keychain Pendant Metal Key Ring',
        alt: 'bear keychains',
        picture: bear2,
        link: 'https://amzn.to/48HcmDn',
    },
    {
        name: 'Screw Back Earrings for Women Girls Steel Heart Earring',
        alt: 'women earings',
        picture: eringsg,
        link: 'https://amzn.to/3P30cxR',
    },
    {
        name: 'Keychain for Women men Rabbit Key Ring Charm',
        alt: 'bunny keychain keytags',
        picture: keychain,
        link: 'https://amzn.to/48vyWyU',
    },
    {
        name: 'Jack Skellington Gifts Keychian for Women Men',
        alt: 'night before christmas keychain',
        picture: skeleton,
        link: 'https://amzn.to/4bZOCO2',
    }
]